import ErrorBoundary from "components/ErrorBoundary";
import configureStore from "data/store";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import EnlisApp from "./EnlisApp";

const store = configureStore();
window.global = window;

// Auto-unregister legacy service workers to prevent stale cache issues
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
      console.log("Unregistered legacy service worker to clear cache.");
    }
  });
}
// Auto-reload on chunk load error (usually after a new deployment)
window.addEventListener("error", (e) => {
  if (
    e.message?.includes("Importing a module script failed") ||
    e.message?.includes("Failed to fetch dynamically imported module")
  ) {
    console.warn("New version detected, auto-refreshing...");
    window.location.reload();
  }
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <EnlisApp />
      </ErrorBoundary>
    </Provider>
  </StrictMode>,
);
